import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import "./Navbar.css";
import {RiMenu3Line, RiCloseLine} from 'react-icons/ri';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Icon } from '@iconify/react';
import slackIcon from '@iconify/icons-mdi/slack';
import logo from '../assets/logo.png';

const Navbar = () => {  
  const [toggleMenu, setToggleMenu] = useState(false);
  const [activeItem, setActiveItem] = useState(() => {
    return localStorage.getItem('activeItem') || null;
  });
  //solidNav tracks background color of navbar. If not on home tab or scrolled on home, soldiNav is true to add a solid background
  const [solidNav, setSolidNav] = useState(false);

  useEffect(() => {
    localStorage.setItem('activeItem', activeItem);

    if (activeItem && activeItem !== 'home') {
      setSolidNav(true);
    } else {
      setSolidNav(false);
    }

  }, [activeItem]);

  const handleItemClick = (itemName) => {
    setActiveItem(itemName)
    setColor(itemName);
    setToggleMenu(false);
  };

  const setColor = (itemName) => ({
    color:'red'
  });

  useEffect(() => {
    const handleSolidNav= () => {
      if (window.scrollY > 0) {
        setSolidNav(true);
      } else if (activeItem === 'home') {
        setSolidNav(false);
      }
    };

    window.addEventListener('scroll', handleSolidNav);

    return () => {
      window.removeEventListener('scroll', handleSolidNav);
    };
  }, [activeItem]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 630) {
        setToggleMenu(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//for slack icon
//npm install --save-dev @iconify/react @iconify/icons-mdi
//slack invite link expires after 30 days
  return (
    <div className={`${solidNav|| toggleMenu ? 'navbar navbarAway' : 'navbar'} ${toggleMenu ? 'navbarExpanded' : ''}`}>
      <div className = "leftLinks">
        <div className = "navHome">
          <Link to="/" className={activeItem === 'home' ? 'active' : ''} onClick={() => handleItemClick('home')}>home</Link>
        </div>
        <div className = "links">
          <Link to="/officers" className={activeItem === 'officers' ? 'active' : ''} onClick={() => handleItemClick('officers')}>officers</Link>
          <Link to="/sponsors" className={activeItem === 'sponsors' ? 'active' : ''} onClick={() => handleItemClick('sponsors')}>sponsors</Link>
          <Link to="/maker_garage" className={activeItem === 'makers' ? 'active' : ''} onClick={() => handleItemClick('makers')}>maker garage</Link>
          <Link to="/events" className={activeItem === 'events' ? 'active' : ''} onClick={() => handleItemClick('events')}>events</Link>
          <Link to="/gallery" className={activeItem === 'gallery' ? 'active' : ''} onClick={() => handleItemClick('gallery')}>gallery</Link>
        </div>
      </div>
      
      <div className="socials">
        <Icon className="social-icons" icon="tabler:brand-linktree" width="25" onClick={() => window.open('https://linktr.ee/weceuf')}/>
        <Icon className="social-icons" icon={slackIcon} width="25" onClick={() => window.open('https://wecegroup.slack.com/join/shared_invite/zt-1eudrc63r-GumP2W1my7cSPOwAIYkFAw#/shared-invite/email')}/>
        <FacebookIcon className="social-icons" onClick={() => window.open('https://www.facebook.com/groups/434483479998047/')}/>
        <InstagramIcon className="social-icons" onClick={() => window.open('https://www.instagram.com/wece_uf/')}/>
  
      </div> 

      <div className="menu">
        {toggleMenu && (
        <div className="menuContainer">
          <div className="menulinks">
            <Link to="/officers" className={activeItem === 'officers' ? 'active' : ''} onClick={() => handleItemClick('officers')}>officers</Link>
          </div>
          <div className="menulinks">
            <Link to="/sponsors" className={activeItem === 'sponsors' ? 'active' : ''} onClick={() => handleItemClick('sponsors')}>sponsors</Link>
          </div>
          <div className="menulinks">
            <Link to="/maker_garage" className={activeItem === 'makers' ? 'active' : ''} onClick={() => handleItemClick('makers')}>maker garage</Link>
          </div>
          <div className="menulinks">
            <Link to="/events" className={activeItem === 'events' ? 'active' : ''} onClick={() => handleItemClick('events')}>events</Link>
          </div>
        </div>
        )}
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />
        }
      </div>
  </div>
  )
}

export default Navbar